import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../models/user';
import { MemoryStorageService } from './memory-storage.service';
import { ENachAPIData } from '../interface/interfaces';

@Injectable({
  providedIn: 'root',
})
export class FinzyService {
  baseUrl: string = '';

  public currentUserSource = new ReplaySubject<User>(1);
  currentUser$ = this.currentUserSource.asObservable();

  private eventSource?: EventSource;

  //use HttpBackend to call http client without interceptor...
  constructor(private httpClient: HttpClient, private router: Router, private zone: NgZone) {
    this.baseUrl = environment.apiUrl;
    this.setCurrentUser(JSON.parse(MemoryStorageService.getItem('user')));
  }

  setCurrentUser(user: User) {
    this.currentUserSource.next(user);
  }

  Additonal_Deatils(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/additional-info',
      obj
    );
  }

  SanctionLoan() {
    return this.httpClient.post(
      this.baseUrl + 'finzy/sanction-loan',
      {}
    );
  }


  InitiateKYC(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/initiate-kyc',
      obj
    );
  }

  UpdateKYC(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/update-kyc',
      obj
    );
  }


  CheckAggregator() {
    return this.httpClient.get(
      this.baseUrl + 'finzy/check-account-aggregator'
    );
  }

  InitiateAA(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/initiate-account-aggregator', obj
    );
  }

  UpdateAggregator(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/update-account-aggregator',
      obj
    );
  }

  UploadDocuments(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/upload-documents',
      obj
    );
  }

  UpdateReference(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/update-reference',
      obj
    );
  }

  UpdateBankInfo(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/update-bankinfo',
      obj
    );
  }

  InitiateVKYC() {
    return this.httpClient.get(
      this.baseUrl + 'finzy/initiate-vkyc'
    );
  }

  UpdateVKYC(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/update-vkyc',
      obj
    );
  }

  InitiateESign() {
    return this.httpClient.get(
      this.baseUrl + 'finzy/initiate-esign'
    );
  }

  UpdateEsign(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/update-esign',
      obj
    );
  }

  initiateENach() {
    return this.httpClient.get(
      this.baseUrl + 'finzy/initiate-enach'
    );
  }
  checkENach() {
    return this.httpClient.get(
      this.baseUrl + 'finzy/check-enach-status'
    );
  }

  initiatePayment() {
    return this.httpClient.get(
      this.baseUrl + 'finzy/initiate-payment'
    );
  }
  UpdatePayment(obj: any) {
    return this.httpClient.post(
      this.baseUrl + 'finzy/update-payment', obj
    );
  }

  // InitiateConsent(obj: any) {
  //   return this.httpClient.post(
  //     this.baseUrl + 'menedo/initiate-consent', obj
  //   );
  // }

  // getServerUpdates(loanId: string, event: string): Observable<string> {
  //   const url = `${this.baseUrl}menedo/${loanId}/${event}`;

  //   return new Observable<string>(observer => {
  //     this.eventSource = new EventSource(url);

  //     this.eventSource.onmessage = (msg) => {
  //       this.zone.run(() => observer.next(msg.data));
  //       this.eventSource?.close();
  //       observer.complete();
  //     };

  //     this.eventSource.onerror = (err) => {
  //       this.zone.run(() => observer.error(err));
  //       this.eventSource?.close();
  //     };

  //     return () => {
  //       this.eventSource?.close();
  //     };
  //   });
  // }

}
